import axiosInstance from '../../api/auth/axiosInstance';
import Swal from 'sweetalert2';
export const PatientService = {
fetchCustomers: async (companyId, mobileTerm = '') => {
    try {
      const response = await axiosInstance.get(`/patients/patient-name-num/${mobileTerm}/${companyId}`, {
        headers: { authType: "PostLogin"} // Assuming patient microservice baseURL3
      });
      return response.data.data.flat();
    } catch (error) {
      console.error("Error fetching customers:", error);
      Swal.fire({
        title: 'Failed!',
        text: `Error fetching customers: ${error.response?.data?.statusDescription || error.message}`,
        icon: 'error',
        confirmButtonColor: '#566fe2',
        customClass: {
          title: 'swal-title-small',
          popup: 'swal-popup-small',
          confirmButton: 'swal-button-small'
        }
      });
      throw error;
    }
  },

     getPatientsRefForVisits: async (patientId,doctorId,date) => {
    try {
      const response = await axiosInstance.get(`/patients/patient-full-ref/${patientId}/${doctorId}/${date}`,{ headers: { authType: "PostLogin" }});
      return response;
    } catch (error) {
      console.error("Error fetching patient details:", error);
      Swal.fire({
  title: 'Failed!',
  text: `Error fetching patient details: ${(error.response?.data?.statusDescription || error.message)}`,
  icon: 'error',
  confirmButtonColor: '#566fe2', // your custom button color
  customClass: {
    title: 'swal-title-small',
    popup: 'swal-popup-small',
    confirmButton: 'swal-button-small'
  }
});
      throw error;
    }
  },
};
  export default PatientService;
